import { api } from './api';

export interface AIUsageStatus {
  [modelId: string]: {
    used: number;
    limit: number;
    remaining: number;
    unlimited: boolean;
  };
}

export interface AIUsageResponse {
  status: AIUsageStatus;
}

// Get AI usage status for all models
export async function getAIUsageStatus(): Promise<AIUsageStatus> {
  const response = await api.get<AIUsageResponse>('/ai/usage/status');
  return response.data.status;
}

// Get remaining requests for a specific model
export async function getRemainingRequests(modelId: string): Promise<number> {
  try {
    const status = await getAIUsageStatus();
    const modelStatus = status[modelId];
    if (!modelStatus) {
      return 10; // Default fallback
    }
    return modelStatus.unlimited ? -1 : modelStatus.remaining;
  } catch (error) {
    console.error('Failed to get AI usage status:', error);
    return 10; // Default fallback on error
  }
}

// Check if a model has unlimited usage
export function isUnlimitedModel(status: AIUsageStatus, modelId: string): boolean {
  const modelStatus = status[modelId];
  return modelStatus?.unlimited || false;
}

// Format usage display text
export function formatUsageText(status: AIUsageStatus, modelId: string): string {
  const modelStatus = status[modelId];
  if (!modelStatus) {
    return '10/10'; // Default fallback
  }
  
  if (modelStatus.unlimited) {
    return '∞';
  }
  
  return `${modelStatus.remaining}/${modelStatus.limit}`;
}
